/**
 * 全角→半角変換関数
 */
export const zen2han = (value: string) => {
  if (!value) { return value }
  let work = value
  work = work.replace(/０/g, '0')
  work = work.replace(/１/g, '1')
  work = work.replace(/２/g, '2')
  work = work.replace(/３/g, '3')
  work = work.replace(/４/g, '4')
  work = work.replace(/５/g, '5')
  work = work.replace(/６/g, '6')
  work = work.replace(/７/g, '7')
  work = work.replace(/８/g, '8')
  work = work.replace(/９/g, '9')
  return work
}
/**
 * ページの先頭にスクロールする
 */
export const scrollTop = () => {
  window.scrollTo(0, 0)
}
